<template>
  <div class="inline-block">
    <div class="w-0px h-0px">
      <div class="transform -translate-x-1/2 -translate-y-1/2"
        :class="{ 'w-[13px] h-[13px]': !IsBig, 'w-[17.5px] h-[17.5px]': IsBig }">
        <div class="relative w-full h-full text-white text-white flex items-center justify-center"
          :class="{ 'text-[8px]': !IsBig, 'text-[9px]': IsBig }">
          <span v-if="props.count > 0 && props.count < 100" class="relative z-2">
            {{ props.count }}
          </span>
          <img v-else-if="props.count > 0 && props.count >= 100" class="w-[10px] h-[2.5px] relative z-2"
            :src="getAssetsFile('home/messageUnreadIconIn.png')" alt="">
          <img :src="getAssetsFile('home/messageUnreadIcon.png')" alt=""
            :class="{ 'w-[14px] h-[15px] left-0px top-1px': !IsBig, 'w-[18.5px] h-[19.5px] left-0px top-1px': IsBig }"
            class="absolute " />
        </div>
      </div>
    </div>
  </div>


</template>

<script setup lang="ts">
import { getAssetsFile } from '@/utils/pub-use'
const props = defineProps<{
  count?: number;
  big?: boolean; // 是否为大红点
}>()

const IsBig = ref(props.big || false)

watch(() => props.big, (newVal) => {
  IsBig.value = newVal
})

watch(() => props.count, (newVal) => {
  IsBig.value = newVal > 99
})

</script>

<style lang="scss" scoped></style>
